module.exports = fox => {
	'use strict';

	const EXO_UDID = require('./exo-udid')(fox);

	fox.registerWidget('Verification_Form', {
		configure() {
			this.registerOptions('', {
				template: 'login_verification_form_en',
				submitSelector: '#form-submit',
				widgets: {
					sendMessageApi: {
						widget: 'Api',
						method: 'site.authorizer.twoFactorAuth'
					},
					verifyCodeApi: {
						widget: 'Api',
						method: 'site.authorizer.verifyCode'
					},
					form: {
						widget: 'DomForm',
						formSelector: '#verification-form',
                        elements: {
                            verificationCode: {
                                validators: [
                                    {
                                        validator: 'regexp',
                                        options: {regexp: /^\d{4}$/},
                                        message: 'Entered code is incorrect'
                                    },
                                    (value) => {
                                        return {
                                            result: (value.length === 4),
                                            message: 'Entered code is incorrect'
                                        };
                                    }
                                ]
                            }
                        }
					},
					action: {
						widget: 'Widget',
						container: '.action-wrapper',
						template: 'login_verification_form_action_en',
						autoRender: true
					}
				},
				handleWom: {
                    formInvaliadate: {
                        widget: '#form',
                        event: ['form_valid', 'form_not_valid'],
                        callback: this._handleFormValidation.bind(this)
                    }
				},
				handleDom: {
					formButtonSubmit: {
						target: '#form-submit',
						callback: '_submit' 
					},
					formSubmit: {
						target: '#verification-form',
						event: 'submit',
						callback: '_submit' 
					},
					focus: {
						target: 'input',
						event: 'focus',
						callback: function(elm) {
							this.toggleFieldError(elm.name, true);
						}
					},
					// input: {
					// 	target: 'input[type="text"]',
					// 	event: 'input',
					// 	callback: function(elm) {
					// 		this.wom1('#form').validate();
					// 	}
					// },
					sendCode: {
						targetWidget: '#action',
						target: "#send-new-code",
						callback: '_sendCode'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init() {
			this._data = {};

			this.callParent('init', arguments);
		},

		prepareEmbeddedWidgets() {
			var w = this.wom1('#action');

			w._bindData = {
                cooldown: 0
			};

			w.bindTemplateVariables(w._bindData, ['cooldown']);

			this.callParent('prepareEmbeddedWidgets', arguments);
		},

		setData(data) {
			this._data = data;

			this.setTemplateOptions('phone', this._data.phone);
		},

		getAuthKey() {
			return this._data.authentificationKey;
		},

		sendMessage() {
			return this._sendMessage({authentificationKey: this.getAuthKey()});
		},

		_sendMessage(data) {
			return this.wom1('#sendMessageApi').psend(data);
		},

		verifyCode(params) {
			var _data = { authentificationKey: this.getAuthKey() };

			if (params && fox.isObject(params)) {
				_data = fox.merge(_data, params);
			}

			return this.wom1('#verifyCodeApi')
				.psend(_data);
		},

		_handleFormValidation(formData) {
			var isValid = true;

            formData.forEach(resp => {
				var $elm = $(this.dom1(''.concat('[name="', resp.field, '"]'))).parent();

				if (resp.result === false) {
					//$elm.addClass('error');
					//$elm.find('.message').text(resp.message);
					this.toggleFieldError(resp.field, false, resp.message);

					return;
				}

				//$elm.removeClass('error');
				//$elm.find('.message').text('');
				this.toggleFieldError(resp.field, true);
			});
		},

		toggleFieldError(name, state, msg) {
            var $elm = $(this.dom1(''.concat('[name="', name, '"]'))).parent();
			
			if (state === true) {
				$elm.removeClass('error');
				$elm.find('.message').text('');
				
				return;
			}

			$elm.addClass('error');
            $elm.find('.message').text(msg);
        },

		_submit(el, alias, w, e) {
			var form = this.wom1('#form');

			fox.jQuery.Event(e).preventDefault();

			form.submit().then(result => {

				if (result === false) {
					return;
				}

				this.togglePreloader(true);

				this.verifyCode(result)
					.then(this._handleVerificationApiResponse.bind(this))
					.catch(this._handleVerificationApiResponse.bind(this));
			});
		},

		_handleVerificationApiResponse(resp) {
			var answer = resp.params.answer;

			this.togglePreloader(false);

			if (answer.status === false) {
				this.dispatchSMSVerificationErrorEvent(answer);

				if (answer.code === 1057) {
					this.toggleFieldError('verificationCode', false, 'Entered code is incorrect');
				}

				return;
			}
			
			this.dispatchSMSVerificationSuccessEvent(answer);
		},

		_sendCode() {
			return this.sendMessage()
				.then(this._handleSendMessageApiResponse.bind(this))
				.catch(this._handleSendMessageApiResponse.bind(this));
		},

		_handleSendMessageApiResponse(resp) {
			var answer = resp.params.answer;

			if (answer.status === false) {
				this.dispatchSMSSendingErrorEvent(answer);

				return answer;
			}
			
			this.dispatchSMSSendingSuccessEvent(answer);
			
			return answer;
		},

		togglePreloader: function(state, widget) {
			widget = widget || this;

			var btn = widget.dom1(this.getOption('submitSelector'));

			if (!btn) {
				return;
			}

			fox.dom[(state ? 'addClass' : 'removeClass')]('spin', btn);
		},

		toggleSubmitButtonInactiveState(state) {
			var btn = this._getSubmitBtn();

			if (!btn) {
				return;
			}

			fox.dom[state === false ? 'addClass' : 'removeClass']('disabled', btn);
		},

		_getSubmitBtn() {
			return this.dom1(this.getOption('submitSelector'));
		},

		getUDID() {
            return EXO_UDID.getShortUid();
		},
		
		getPhoneNumberParams() {
			var formData = this.phoneNumberForm.getValues();
			var code = formData.phoneType.replace(/^00/, '');

			if (!code.match(/^\+/)) {
				code = '+'.concat(code);
			}
			
			return {code, phone: formData.phoneNumber};
		},
		
		dispatchSMSSendingErrorEvent(answer) {
			this.dispatchEvent('sms_sending_error', answer);
		},

		dispatchSMSSendingSuccessEvent(answer) {
			this.dispatchEvent('sms_sending_success', answer);
		},

		dispatchSMSVerificationErrorEvent(answer) {
			this.dispatchEvent('sms_verification_error', answer);
		},

		dispatchSMSVerificationSuccessEvent(answer) {
			this.dispatchEvent('sms_verification_success', answer);
		},

		switchActionWidgetState(state, params) {
			var w = this.wom1('#action');
			var SUCCESS_STATE_TIME = 5;

			w.setTemplateOptions({state});
			w.render();

			this.wait(w, 'addedToDom', {prefix: 'action_widget_render'}).then(() => {
				
				if (state === 'success') {
					this.runCountDown(SUCCESS_STATE_TIME).then(() => {
						var cooldown = params.cooldown - SUCCESS_STATE_TIME;
	
						if (cooldown > 0) {
							this.switchActionWidgetState('cooldown', {cooldown});
							this.updateCooldown(cooldown);
						}
					});
				}
	
				if (state === 'cooldown') {
					this.updateCooldown(params.cooldown);
	
					this.runCountDown(params.cooldown, timeLeft => {
						this.updateCooldown(timeLeft);
					}).then(() => {
						this.switchActionWidgetState('available');
					});
				}
			});
		},

		runCountDown(cooldown, periodCallback) {
			var w = this.wom1('#action');

			// if (w._indom === false) {
			// 	this.wait(w, 'addedToDom', {prefix: 'action_widget_render'}).then(() => {
			// 		this.runCountDown(cooldown, periodCallback);
			// 	});

			// 	return fox.Promise.reject();
			// }

			return this.startCountDown(cooldown, periodCallback).catch(console.error);
		},

		stopCountDown() {
			window.clearInterval(this.countDownInt);

			delete this.countDownInt;
		},

		startCountDown(seconds, periodCallback) {
			this.stopCountDown();

			return new fox.Promise(resolve => {
				var i = 0;
				this.countDownInt = window.setInterval(() => {
					++i;

					if (i === seconds) {
						this.stopCountDown();
						
						return resolve(true);;
					}
					
					if (fox.isFunction(periodCallback)) {
						periodCallback(seconds-i);
					}

				}, 1000);
			});
		},

		transformSecondsToMinutes(s) {
			return (s-(s%=60))/60+(9<s?':':':0')+s;
		},

		updateCooldown(time) {
			var w = this.wom1('#action');

			w._bindData.cooldown = this.transformSecondsToMinutes(time);
		}
	});
};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/verification-form/verification-form.es.js